import type { TermsTexts } from "../../api/types";
import { t } from "../../i18n";
import { Markdown } from "../../lib/markdown";
import { Dialog } from "../../ui/Dialog";
import type { LegalDocument } from "./TermsGate";

interface Props {
  /** The version and its texts (the till gets them with the shop's details; Tafo-beheer without). */
  texts: Pick<TermsTexts, "version" | "texts">;
  document: LegalDocument;
  onClose: () => void;
}

/** One legal text to read (prototype openLegal): the terms, the data processing agreement or the privacy statement. */
export function LegalDialog({ texts, document, onClose }: Props) {
  return (
    <Dialog
      title={
        <>
          {t.terms.documents[document]} <small className="muted">{t.terms.version(texts.version)}</small>
        </>
      }
      size="legal"
      onClose={onClose}
      footer={
        <>
          <span className="spacer" />
          <button type="button" className="btn" onClick={onClose}>
            {t.terms.close}
          </button>
        </>
      }
    >
      <div className="legal-doc">
        <Markdown source={texts.texts[document]} />
      </div>
    </Dialog>
  );
}
